var map = {
	"./testing.ar": [
		7973,
		2803
	],
	"./testing.ar.jsx": [
		7973,
		2803
	],
	"./testing.de": [
		8809,
		5023
	],
	"./testing.de.jsx": [
		8809,
		5023
	],
	"./testing.en": [
		5981
	],
	"./testing.en.jsx": [
		5981
	],
	"./testing.es": [
		7412,
		8422
	],
	"./testing.es.jsx": [
		7412,
		8422
	],
	"./testing.fr": [
		8264,
		462
	],
	"./testing.fr.jsx": [
		8264,
		462
	],
	"./testing.it": [
		3207,
		3805
	],
	"./testing.it.jsx": [
		3207,
		3805
	],
	"./testing.ja": [
		7079,
		7521
	],
	"./testing.ja.jsx": [
		7079,
		7521
	],
	"./testing.ko": [
		1358,
		468
	],
	"./testing.ko.jsx": [
		1358,
		468
	],
	"./testing.nl": [
		9274,
		2920
	],
	"./testing.nl.jsx": [
		9274,
		2920
	],
	"./testing.pt-BR": [
		955,
		8547
	],
	"./testing.pt-BR.jsx": [
		955,
		8547
	],
	"./testing.zh-Hans": [
		5217,
		1589
	],
	"./testing.zh-Hans.jsx": [
		5217,
		1589
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1383;
module.exports = webpackAsyncContext;